// extracted by css-extract-rspack-plugin
export default {"input":"input-module__input___YdvVI","label":"input-module__label___nunl9","error":"input-module__error___KGIEW"};